/**
 * Pages removed from the theme. Site-level page settings can still carry
 * entries for them, so the nav and sitemap exclude these aliases explicitly.
 */
export const REMOVED_PAGE_ALIASES: ReadonlySet<string> = new Set([
  'studios',
  '1-bedroom',
  '2-bedrooms',
  '3-bedrooms',
  'townhomes',
  'featured-floor-plan',
]);
